module.exports = __webpack_public_path__ + "static/media/ICE-FTM.9a1b5091.png";